export default {
  brand: 'Guangzhou Jianguly Network Technology Co., Ltd.',
  'nav.home': 'Home',
  'nav.services': 'Services',
  'nav.cases': 'Cases',
  'nav.testimonials': 'Testimonials',
  'nav.process': 'Process',
  'nav.contact': 'Contact',
  'cta.freeConsult': 'Free Consultation',
  'hero.title1': 'Professional Software Development',
  'hero.title2': 'Empower Your Digital Transformation',
  'hero.desc1': 'We provide website, mini-program, and app development, plus PHP→Go migration consulting',
  'hero.desc2': 'Turn technology into a powerful engine for your business growth',
  'hero.learn': 'Learn Services',
  'lang.zh': '中文',
  'lang.en': 'English',
  'services.title': 'Professional Services',
  'services.intro': 'We provide end-to-end software development from frontend to backend, from design to deployment, delivering complete technical solutions for your business',
  'services.techTitle': 'Technical Advantages',
  'services.items.web.title': 'Website Development',
  'services.items.web.desc': 'Responsive corporate websites, e-commerce platforms, and admin systems with modern tech stack for performance and UX',
  'services.items.web.features': ['Responsive design', 'SEO optimization', 'High-performance architecture', 'Security protection'],
  'services.items.mini.title': 'Mini-program Development',
  'services.items.mini.desc': 'WeChat/Alipay mini-programs across platforms to help businesses quickly join the mobile ecosystem',
  'services.items.mini.features': ['Multi-platform', 'Native-like experience', 'Fast deployment', 'Data analytics'],
  'services.items.app.title': 'App Development',
  'services.items.app.desc': 'Native iOS and Android apps, full mobile solutions from design to store release',
  'services.items.app.features': ['Native development', 'Cross-platform compatibility', 'App store release', 'Maintenance'],
  'services.items.migration.title': 'PHP→Go Migration',
  'services.items.migration.desc': 'Expert consulting to smoothly migrate from PHP to Go, boosting performance and maintainability',
  'services.items.migration.features': ['Architecture refactor', 'Performance optimization', 'Smooth migration', 'Training'],
  'cases.title': 'Success Cases',
  'cases.intro': 'We have delivered quality software services for many enterprises. Here are selected case studies',
  'cases.categories.all': 'All',
  'cases.categories.web': 'Web',
  'cases.categories.mini': 'Mini-program',
  'cases.categories.app': 'App',
  'cases.categories.blockchain': 'Blockchain',
  'cases.categories.migration': 'Migration',
  'cases.categories.ai': 'AI System',
  'cases.items.1.title': 'AI-powered Admin System',
  'cases.items.1.desc': 'Enterprise admin system with conversational AI to generate various data reports, making analysis simple and intuitive.',
  'cases.items.2.title': 'E-commerce Mini-program',
  'cases.items.2.desc': 'Feature-rich e-commerce mini-program with product display, cart, payment, and order management.',
  'cases.items.3.title': 'Corporate Website Rebuild',
  'cases.items.3.desc': 'Responsive corporate website with modern design, optimized UX and SEO performance.',
  'cases.items.4.title': 'NFT Digital Collectibles Platform',
  'cases.items.4.desc': 'Complete NFT marketplace supporting minting, display, trading, and auctions, building a digital art ecosystem.',
  'cases.items.5.title': 'Mobile Office App',
  'cases.items.5.desc': 'Enterprise mobile office solution integrating attendance, approvals, communication, and document management.',
  'cases.items.6.title': 'DeFi Liquidity Mining Platform',
  'cases.items.6.desc': 'Decentralized finance platform with liquidity mining, staking yields, and token swaps.',
  'cases.items.7.title': 'Online Education Platform',
  'cases.items.7.desc': 'Comprehensive e-learning platform with live classes, playback, assignments, and grade management.',
  'cases.items.8.title': 'Blockchain Supply Chain Traceability',
  'cases.items.8.desc': 'Blockchain-based supply chain system for full product traceability and anti-counterfeiting.',
  'cases.items.9.title': 'Intelligent Customer Service Mini-program',
  'cases.items.9.desc': 'Mini-program with AI customer service, supporting auto-reply, human support, and ticket management.',
  'cases.items.10.title': 'Smart Contract Audit Platform',
  'cases.items.10.desc': 'Professional smart contract security audit platform for code scanning, vulnerability analysis and fixes.',
  'cases.items.11.title': 'PHP→Go System Migration',
  'cases.items.11.desc': 'Large e-commerce platform migration from PHP to Go, achieving 300% performance improvement and higher concurrency.',
  'cases.items.12.title': 'Data Analytics Visualization Platform',
  'cases.items.12.desc': 'Enterprise data analytics platform with AI-driven customized reports and multi-dimensional visualization.',
  'cases.stat.users': 'Users',
  'cases.stat.rating': 'Rating',
  'cases.stat.duration': 'Duration',
  'testimonials.title': 'Testimonials',
  'testimonials.intro': 'Client recognition drives us forward. Here are authentic testimonials from our clients',
  'stats.projects': 'Projects',
  'stats.clients': 'Clients',
  'stats.satisfaction': 'Satisfaction',
  'stats.support': 'Support',
  'process.title': 'Process',
  'process.intro': 'We follow a standardized project management process to ensure on-time, quality delivery',
  'process.items.1.title': 'Requirement Communication',
  'process.items.1.desc': 'Understand your business needs, analyze feasibility, and draft an initial solution',
  'process.items.1.details': ['Requirement analysis', 'Technical feasibility', 'Scope definition', 'Initial solution'],
  'process.items.2.title': 'Solution Design',
  'process.items.2.desc': 'Design technical solution and project plan to ensure smooth progress',
  'process.items.2.details': ['Architecture design', 'UI/UX design', 'Development plan', 'Risk assessment'],
  'process.items.3.title': 'Development',
  'process.items.3.desc': 'Agile development in phases with regular progress reporting',
  'process.items.3.details': ['Agile process', 'Code quality', 'Regular updates', 'Milestone delivery'],
  'process.items.4.title': 'Testing & Deployment',
  'process.items.4.desc': 'Comprehensive testing, deployment assistance, and training',
  'process.items.4.details': ['Functional testing', 'Performance testing', 'Security testing', 'Deployment'],
  'process.items.5.title': 'Maintenance & Support',
  'process.items.5.desc': 'Continuous technical support and maintenance for stability',
  'process.items.5.details': ['Technical support', 'System maintenance', 'Feature upgrades', 'Issue resolution'],
  'contact.title': 'Contact Us',
  'contact.subtitle': 'Ready to start your project? Our team is here for consulting and solutions',
  'contact.methodsTitle': 'Contact Methods',
  'contact.phoneTitle': 'Phone',
  'contact.mailTitle': 'Email',
  'contact.addressTitle': 'Address',
  'contact.hours': 'Mon–Fri 9:00–18:00',
  'contact.reply': 'Reply within 24 hours',
  'contact.formTitle': 'Project Inquiry',
  'contact.form.name': 'Name *',
  'contact.form.namePlaceholder': 'Enter your name',
  'contact.form.company': 'Company',
  'contact.form.companyPlaceholder': 'Enter company name',
  'contact.form.phone': 'Phone *',
  'contact.form.phonePlaceholder': 'Enter phone number',
  'contact.form.email': 'Email',
  'contact.form.emailPlaceholder': 'Enter email address',
  'contact.form.service': 'Service Type *',
  'contact.form.servicePlaceholder': 'Select a service',
  'contact.form.blockchain': 'Blockchain Development',
  'contact.form.consulting': 'Consulting',
  'contact.form.other': 'Other',
  'contact.form.budget': 'Budget',
  'contact.form.budgetPlaceholder': 'Select a budget',
  'contact.form.budgetRanges': ['< ¥50k', '¥50k–¥100k', '¥100k–¥200k', '¥200k–¥500k', '> ¥500k', 'Negotiable'],
  'contact.form.message': 'Project Description *',
  'contact.form.messagePlaceholder': 'Please describe your project requirements in detail (max 500 chars)',
  'contact.form.submit': 'Submit Inquiry',
  'contact.form.submitting': 'Submitting...',
  'footer.quick': 'Quick Links',
  'footer.contact': 'Contact',
  'footer.intro1': 'We deliver high-quality website, mini-program, and app development services.',
  'footer.intro2': 'Our experienced team empowers your digital transformation.'
}
